import { HttpLink } from '@apollo/client';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { getCustomHeaders } from 'services/apollo-client/links/auth-link';

export default new BatchHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_URL,
  headers: getCustomHeaders(),
});

//export default new HttpLink({ uri: process.env.REACT_APP_GRAPHQL_URL,headers: getCustomHeaders(), });
